// extracted by mini-css-extract-plugin
export default {"p":"_07b8ac0037 ffdd969fb1 c018fd9813","clr":"e71b65f33a","dls":"_173894b89f"};